import sidepanelArrow from "./../../assets/images/sidepanelarrow.svg";
import user from "./../../assets/images/user.svg";
import email from "./../../assets/images/email.svg";
import phone from "./../../assets/images/phone.svg";
import aiValueDefault from './../../assets/images/donut-chart.svg'
import done from './../../assets/images/done.svg'
import inProgress from './../../assets/images/progress.svg'
import notStarted from './../../assets/images/stop.svg'
import journey from './../../assets/images/journey.svg'

export const Images = {
    sidepanelArrow,
    incorpLogo: require("./../../assets/images/logo.png"),
    navigatorLogo: require("./../../assets/images/navigator.png"),
    evaluation1: require("./../../assets/images/Evaluation1.jpg"),
    evaluation2: require("./../../assets/images/Evaluation2.jpg"),
    aiValueFlow: require("./../../assets/images/ai-value-image.jpg"),
    aiRoadmap: require("./../../assets/images/ai-roadmap.jpg"),
    aiUsecase: require("./../../assets/images/ai-use-case.jpg"),
    timelineCost: require("./../../assets/images/timline-cost.jpg"),
    timelineScale: require("./../../assets/images/scale.png"),
    timelineCDAP: require("./../../assets/images/cdap.png"),
    timelineArc: require("./../../assets/images/arc.png"),
    timelineSred: require("./../../assets/images/sred.png"),
    timelineBDC: require("./../../assets/images/bdc.png"),
    differentiator: require("./../../assets/images/Differentiation-image.jpg"),
    leaf: require("./../../assets/images/leaf.png"),
    user,
    email,
    phone,
    aiStrategy: require("./../../assets/images/icon1.jpg"),
    aiValue: require("./../../assets/images/icon2.jpg"),
    aiOrganization: require("./../../assets/images/icon3.jpg"),
    aiPeople: require("./../../assets/images/icon4.jpg"),
    aiGovernance: require("./../../assets/images/icon5.jpg"),
    aiEngineering: require("./../../assets/images/icon6.jpg"),
    aiData: require("./../../assets/images/icon7.jpg"),
    icon1: require("./../../assets/images/icon1.jpg"),
    icon2: require("./../../assets/images/icon2.jpg"),
    icon3: require("./../../assets/images/icon3.jpg"),
    icon4: require("./../../assets/images/icon4.jpg"),
    icon5: require("./../../assets/images/icon5.jpg"),
    icon6: require("./../../assets/images/icon6.jpg"),
    icon7: require("./../../assets/images/icon7.jpg"),
    whyIncorpAI: require("./../../assets/images/why-incorp.jpg"),
    aiValueDefault,
    done,
    inProgress,
    notStarted,
    journey,

}